import { apiClient } from './apiClient';
import type { ApiResponse, PaginatedResponse, BankTransaction, BankTransactionFilters, PaginationParams } from '../types/api';

class BankTransactionService {
  async getBankTransactions(filters?: BankTransactionFilters, params?: PaginationParams): Promise<ApiResponse<PaginatedResponse<BankTransaction>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (filters?.profileId) queryParams.append('profileId', filters.profileId);
    if (filters?.dateFrom) queryParams.append('dateFrom', filters.dateFrom);
    if (filters?.dateTo) queryParams.append('dateTo', filters.dateTo);
    if (filters?.search) queryParams.append('search', filters.search);

    return await apiClient.get<PaginatedResponse<BankTransaction>>(`/dev/bank-transactions?${queryParams.toString()}`);
  }
}

export const bankTransactionService = new BankTransactionService();
export default bankTransactionService;

